import { cn } from "@/lib/utils";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "./hover-card";

export function CardTooltip({
	trigger,
	label,
	className,
	triggerClassName,
}: {
	trigger: React.ReactNode;
	label: React.ReactNode;
	className?: string;
	triggerClassName?: string;
}) {
	return (
		<HoverCard>
			<HoverCardTrigger asChild>
				<div className={cn("icon-wrapper !w-fit", triggerClassName)}>
					{trigger}
				</div>
			</HoverCardTrigger>
			<HoverCardContent
				className={cn(
					"min-w-32 p-2 text-sm text-t1 mt-2 text-center",
					className,
				)}
			>
				{label}
			</HoverCardContent>
		</HoverCard>
	);
}
